<script lang="ts">
	/**
	 * The documentation and support links an application publishes.
	 *
	 * They point away from Abstract ID, so each is a real anchor with
	 * `rel="noopener noreferrer"` rather than a router push — and they render as
	 * cards rather than a list because a link with an icon and a sentence of
	 * explanation is a destination, not a menu item.
	 */

	import type { ApplicationLink } from '../AppTypes';

	interface Props {
		/** Links to show. An empty list renders nothing at all. */
		links: ApplicationLink[];
	}

	let { links }: Props = $props();
</script>

{#if links.length > 0}
	<div class="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
		{#each links as link (link.url)}
			<a
				href={link.url}
				target="_blank"
				rel="noopener noreferrer"
				class="widget bg-depth-hover group flex h-full items-start gap-3 !p-4 transition hover:shadow-md"
			>
				<div class="bg-primary-100 dark:bg-primary-900/30 shrink-0 rounded-lg p-3">
					<i class="fa-solid {link.icon || 'fa-book'} text-primary-600 dark:text-primary-400 text-lg"></i>
				</div>
				<div class="min-w-0 flex-1">
					<p class="truncate font-medium text-gray-900 dark:text-white">{link.name}</p>
					{#if link.description}
						<p class="mt-0.5 line-clamp-2 text-xs text-gray-500 dark:text-gray-400">{link.description}</p>
					{/if}
				</div>
				<i
					class="fa-solid fa-arrow-up-right-from-square group-hover:text-primary-500 mt-1 text-xs text-gray-300 transition dark:text-gray-600"
				></i>
			</a>
		{/each}
	</div>
{/if}
